



































































































import { Component, Vue, Watch } from 'vue-property-decorator'
import PageHeader from '@/components/PageHeader.vue'
import Toggler from '@/components/Toggler.vue'
import { Money } from 'v-money'
import NavigationFooter from '@/components/NavigationFooter.vue'
import TrackingMixin from '@/mixins/TrackingMixin.vue'
import { mapActions, mapGetters } from 'vuex'
import ticketsCostToggleOptions from '@/store/data/ticketsCostToggleOptions'
import IToggleOption from '@/store/interface/IToggleOption'
/**
 * TicketsCost Page
 *
 * This page uses v-money lib to retreive the tickets price, formats it to
 * number, and sends to the backend
 */
@Component({
	name: 'TicketsCostPage',
	components: {
		PageHeader,
		Money,
		Toggler,
		NavigationFooter
	},
	mixins: [TrackingMixin],
	computed: {
		...mapGetters({
			refundId: 'refundData/getRefundId'
		})
	},
	methods: {
		...mapActions({
			setTicketPriceData: 'refundData/setTicketPriceData'
		})
	}
})
export default class TicketCostPage extends Vue {
	private refundId!: string
	private setTicketPriceData!: Function
	private ticketPrice: string = ''
	private extraCharge: string = ''
	private formattedTicketPrice: number = 0
	private formattedExtraCharge: number = 0
	private isPageValid: boolean = false
	private moneyFormatForComponent: any = {
		decimal: '.',
		thousands: ',',
		prefix: '',
		suffix: ' €',
		precision: 2,
		masked: true
	}
	private flightDescription: string = ''
	private isGermanDomain: boolean = this.$i18n.locale === 'de_DE'
	private ticketsCostToggleList: IToggleOption[] = ticketsCostToggleOptions
	private originalTicketPriceRefunded: boolean | null = null
	private alternativeTransportTaken: boolean | null = null
	private nextStep: string = 'step6'

	mounted () {
		if (this.refundId === '') {
			this.$router.push('step0').catch(e => console.error(e))
		}
	}

	@Watch('ticketPrice')
	priceWatcher () {
		this.formattedTicketPrice = parseFloat(this.ticketPrice.replace(',', ''))
		const ticketPriceIsValid = Math.floor(this.formattedTicketPrice) > 0

		if (this.isGermanDomain) {
			this.validate()
		} else {
			this.isPageValid = ticketPriceIsValid
		}
	}

	@Watch('extraCharge')
	extraPriceWatcher () {
		if (this.alternativeTransportTaken) {
			this.formattedExtraCharge = parseFloat(this.extraCharge.replace(',', ''))
			this.validate()
		}
	}

	private validate (): void {
		const ticketPriceIsValid: boolean = Math.floor(this.formattedTicketPrice) > 0
		const extraChargeIsValid: boolean = Math.floor(this.formattedExtraCharge) > 0
		let bothPricesAreValid: boolean = ticketPriceIsValid && extraChargeIsValid
		const alternativeTransportIsNotTaken: boolean = this.alternativeTransportTaken === false && this.alternativeTransportTaken !== null

		if (this.originalTicketPriceRefunded) {
			this.alternativeTransportTaken = null
			this.extraCharge = '0'
			this.nextStep = 'no-claim'
			this.isPageValid = ticketPriceIsValid
		} else {
			// Reset extra charge when the input is hidden
			if (!this.alternativeTransportTaken) {
				this.extraCharge = '0'
				bothPricesAreValid = false
			}
			this.nextStep = 'step6'
			this.isPageValid = (bothPricesAreValid) || (ticketPriceIsValid && alternativeTransportIsNotTaken)
		}
	}

	private onTicketRefundedChange (value: boolean): void {
		this.originalTicketPriceRefunded = value
		this.validate()
	}

	private onAlternativeTransportTakenChange (value: boolean): void {
		this.alternativeTransportTaken = value
		this.validate()
	}

	private onPageSubmit (): void {
		const payload = {
			ticketPrice: this.formattedTicketPrice,
			flightDescription: this.flightDescription,
			alternativeTicketPrice: this.formattedExtraCharge,
			originalTicketPriceRefunded: this.originalTicketPriceRefunded,
			alternativeTransportTaken: this.alternativeTransportTaken
		}

		if (this.nextStep === 'step6') {
			this.setTicketPriceData(payload)
				.then(() => {
					this.$router.push(this.nextStep)
			})
		} else {
			this.$router.push(this.nextStep)
		}
	}
}
